module.exports = __webpack_public_path__ + "static/media/partitions_lcs_60yd_y.059bb81c.csv";